// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__egjw4","nav":"Breadcrumbs_nav__Zfu1W"};